import { useEffect } from 'react';
import { message } from 'antd';

import {
  useClaimBusiness as useClaimBusinessApi,
} from '../../../hooks/api/claimBusiness';
import { getMessageInError } from '../../../hooks/fetch';

export const useClaimBusiness = (id: string | undefined) => {
  const {
    fetch: claimBusiness, response, error, loading,
  } = useClaimBusinessApi(id);

  useEffect(() => {
    if (response?.data.success) {
      message.success('Business claimed successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  return {
    claimBusiness,
    response,
    error,
    loading,
  };
};

export default useClaimBusiness;
